import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IAccountReceivableCreate } from "../../../domain/IAccountReceivableCreate";
import { FormatDateIso } from "utils/dateUtils";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import {
  createAccountReceivable,
  setNewAccountReceivablePopover,
} from "../accountReceivable.slice";
import { useAppDispatch } from "hooks/hooks";
import { Controller, useForm } from "react-hook-form";
import { styles } from "../../../../../../components/Popover/popoverSelectStyle";
import { selectPartner } from "../../Main/main.slice";
import ProjectSelectForReceivable from "Dashboard/scenes/Projects/components/ProjectSelectForReceivable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesPartners from "../../../styles/popovers.module.scss";
import NumberInput from "Dashboard/components/NumberInput";
import { IProjectOption } from "Dashboard/domain/IProjectOption";

interface IProps {
  projects: IProjectOption[];
}

export const NewAccountReceivablePopover = ({ projects }: IProps) => {
  const dispatch = useAppDispatch();
  const partner = useSelector(selectPartner);

  const {
    handleSubmit,
    register,
    control,
    formState: { errors, isSubmitting },
    reset,
  } = useForm<IAccountReceivableCreate>();

  const closeDialog = () => {
    dispatch(setNewAccountReceivablePopover({ isOpen: false }));
    reset();
  };

  const onSubmit = async (data: IAccountReceivableCreate) => {
    try {
      await dispatch(createAccountReceivable(data)).unwrap();
      closeDialog();
      toast.success("Red je uspesno dodat.");
    } catch (status: any) {
      if (status === 404) {
        toast.error("Unos nije moguć jer neki od unetih podataka nije regularan");
      } else if (status === 403) {
        toast.error("Ova operacija nije dozvoljena za vas");
      } else if (status === 400) {
        toast.error("Unos nije moguć zbog neočekivane greške");
      }
    }
  };

  if (!partner) return <div>Morate da izaberete partnera</div>

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={`
      ${classesPartners.newAccountReceivablePopover}
      ${classes.basicPopover}`}
    >
      <input
        type="hidden"
        value={partner.partnerId}
        {...register("partnerId")}
      />

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>ime saradnika</label>
          <input type="text" className={`${classes.itemBorder}
            ${classes.transparent} ${classes.lightDark}`}
            value={partner.fullName} disabled />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>br. fakture</label>
          <input type="text" className={`${classes.itemBorder}
            ${errors?.invoiceId ? classes.itemError : ""}`}
            {...register("invoiceId", { required: true })} />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir} 
          ${classes.alignCenter} ${errors.projectId ? classes.itemError : ""}`}>
          <label className={classes.mr5}>za koji posao</label>
          <Controller
            name="projectId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <ProjectSelectForReceivable
                onChange={onChange}
                customStyles={styles.customStyleClassic}
                error={errors.projectId}
                preloadedOptions={projects}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>datum</label>
          <Controller
            control={control}
            name="invoiceDate"
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value } }) => (
              <div>
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? FormatDateIso(date) : undefined)
                  }
                  dateFormat="dd.MM.yyyy"
                  showMonthDropdown
                  showYearDropdown
                  selected={value ? new Date(value) : null}
                  className={`${classes.dateItem} ${classes.itemBorder}
                    ${errors.invoiceDate ? classes.itemError : ""}`}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>valuta</label>
          <Controller
            control={control}
            name="dueDate"
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value } }) => (
              <div>
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? FormatDateIso(date) : undefined)
                  }
                  dateFormat="dd.MM.yyyy"
                  showMonthDropdown
                  showYearDropdown
                  selected={value ? new Date(value) : null}
                  className={`${classes.dateItem} ${classes.itemBorder}
                    ${errors.invoiceDate ? classes.itemError : ""}`}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>iznos</label>
          <Controller
            control={control}
            name="amountInvoiced"
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value } }) => (
              <NumberInput
                formatAs="quantity"
                onChange={(value: string, unmaskedValue: string, parsedValue: number) => onChange({ target: { value: unmaskedValue } })}
                className={`${classes.itemBorder} ${errors.amountInvoiced ? classes.itemError : ""}`}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>avans</label>
          <div>
            <input type="checkbox" className={`${classes.itemBorder}
            ${errors?.isAdvance ? classes.itemError : ""}`}
              {...register("isAdvance", { required: false })} />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button className={classes.iconButton} type="submit" disabled={isSubmitting}>
            <FontAwesomeIcon icon={faLongArrowAltDown} className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};
